module.exports = __webpack_public_path__ + "static/media/acm_logo.105ef257.png";